import { UserService } from './user.service';

export const userService = new UserService();
